// Parse an employee-name list out of an uploaded workbook (.xlsx/.xls/.csv). Kept pure and with `XLSX`
// injected so it can be unit-tested without the SheetJS bundle. Heuristic: one name per row — the first
// non-empty, non-numeric cell (so an index column like "1 | NAME" is skipped) — across every sheet, a
// leading header row dropped, trimmed and de-duplicated (case-insensitive) while preserving order.

const HEADER = /^(a\/a|no\.?|#|name|names|full ?name|surname|όνομα|ονοματεπ|επών|εργαζ|employee|υπάλληλ)/i;
const NUMERIC = /^\d+([.,]\d+)?$/;

/** first non-empty, non-numeric cell in a row, trimmed. */
function nameFromRow(row: unknown[]): string {
  for (const c of row) {
    const s = String(c ?? '').trim();
    if (s && !NUMERIC.test(s)) return s;
  }
  return '';
}

export function parseNamesWorkbook(XLSX: any, buf: ArrayBuffer): string[] {
  const wb = XLSX.read(buf, { type: 'array' });
  const out: string[] = [];
  const seen = new Set<string>();
  for (const sheetName of wb.SheetNames as string[]) {
    const ws = wb.Sheets[sheetName];
    if (!ws) continue;
    const aoa: unknown[][] = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '', blankrows: false, raw: false });
    let first = true;
    for (const row of aoa) {
      let name = nameFromRow(row);
      if (first) { first = false; if (HEADER.test(name)) continue; }
      if (!name) continue;
      if (name.length > 120) name = name.slice(0, 120);
      const key = name.toUpperCase();
      if (seen.has(key)) continue;
      seen.add(key);
      out.push(name);
    }
  }
  return out;
}
